export default __webpack_public_path__ + "static/media/A.841d2ab7.svg";